import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCustomer: null,
  filters: {
    search: '',
  },
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setSelectedCustomer, setFilters, clearFilters } =
  customersSlice.actions;
export default customersSlice.reducer;
